import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-layout-grid-line text-lg text-primary-500"></i>
              </div>
              <span className="font-heading text-base font-semibold text-foreground-900 whitespace-nowrap">
                Vigorbuy Spreadsheet
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-xs">
              Your smart gateway to premium product discovery. Browse, compare, and shop across 14 curated categories with ease.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Home</Link>
              </li>
              <li>
                <a href="#categories" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Product Categories</a>
              </li>
              <li>
                <a href="#features" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Features</a>
              </li>
              <li>
                <a href="#how-it-works" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">How It Works</a>
              </li>
              <li>
                <a href="#faq" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">FAQ</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              SEO Guides
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/vigorbuy-spreadsheet-shopping-guide" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Shopping Guide</Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-guide" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Complete Guide</Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-review" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Platform Review</Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-tips" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Tips & Tricks</Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-benefits" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Benefits Overview</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/vigorbuy-spreadsheet-features" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Features Guide</Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-security" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Security Analysis</Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-vs-excel" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Vs Excel Comparison</Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 cursor-pointer">Main Website</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 hover:text-primary-500 text-xs transition-colors duration-200 cursor-pointer">Privacy</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 hover:text-primary-500 text-xs transition-colors duration-200 cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}